import { c as create_ssr_component, d as each, e as escape, b as add_attribute, f as compute_rest_props, v as validate_component, g as spread, h as escape_attribute_value, i as escape_object } from "./ssr.js";
const sources$v = {
  webp: [
    {
      src: "/_app/immutable/assets/arua-hill-sc.733Scw4M.webp",
      w: 50
    }
  ]
};
const img$v = {
  src: "/_app/immutable/assets/arua-hill-sc.8vJi42FM.png",
  w: 50,
  h: 50,
  lqip: "UklGRlABAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKsAAAABgFvbtmpl3+/uSgcOVbhbBwwyhwKgA6iEQQnu7hIS/Yj4yTkbu58WImICABNAtH1ypieBQACAMcHZeyH1fS2GAAzSO1QVUeFBHQZmm45Pkr7LoyQwR5dWhxsIXVFswo98u1BtKuydoLBJj/Mz/1nqJrUJ4WDskWJTNqpYo2tzuQlEd+nKL3H5VIJByylVPE+Eb60IIIDUeoOq/NwqIQAgEECub2F5uIJAAAAAVlA4IH4AAABwAgCdASoQABAABUB8JbACdAYuEgAOTxWkB2ngAPrtwjDVE0j7/X/oVBMi9gq+HpylZyVC6FSpxwGBVd1wGxqWL4CjYk7Up649Kv3B5af4tLJ1GO3MH+ELr3ZMHvkKrTKcz82GzW+dB5KR5rF8m7gl11VzDbaoj8pcQRgAAAA="
};
const __vite_glob_0_0 = {
  sources: sources$v,
  img: img$v
};
const sources$u = {
  webp: [
    {
      src: "/_app/immutable/assets/bul-fc.v3yVq1mL.webp",
      w: 50
    }
  ]
};
const img$u = {
  src: "/_app/immutable/assets/bul-fc.EhU0gbSt.png",
  w: 50,
  h: 50,
  lqip: "UklGRgwBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSGkAAAABYBRJkpTe/a6gDYTeTpBCIOQa6OYeJESEwrZtm+x0V2cgROR2nOexzYgBAana9dC9Srf32owSbVOfgFIr9VCuKlEYXy6RVlQyfaipGsQvoYZJjk6++I27pPYP8jm4nH5wfHDubs7dzRkAVlA4IHwAAABwAgCdASoQABAABUB8JbACdDiAN5AA6fQ12P7YAMv9Axsm7wuck9KZKDIM1b0Woig8By3Yq1+g5Q5nRf7G7kQ0/hpKBov56mZI2WykFT/ilPAklv/bkq7V6fFN+HaK9zmRugKFaeT7pm5bF29i/oqBPf1YNDaORO8PwAAA"
};
const __vite_glob_0_1 = {
  sources: sources$u,
  img: img$u
};
const sources$t = {
  webp: [
    {
      src: "/_app/immutable/assets/busoga-united-fc.ZSqvCjdB.webp",
      w: 50
    }
  ]
};
const img$t = {
  src: "/_app/immutable/assets/busoga-united-fc.9DcRrYp_.png",
  w: 50,
  h: 50,
  lqip: "UklGRkoBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKkAAAABgJpt27Llet4fd8hUoiVNTGAzsAHRPZMcGpkJXAaguUzgLu/7fvfv/woRMQGAM/KnjLxVA2PL20sjLeQ6Bm+VSIkeFysxg1MF/+99VOwjZdiJgiQlyX9/DmcFFPtKCT04g9NCvjvHnRXRg8PYK/TbhaOmejpf1HlLFVSu30YfpPivh91WqF/5epOil/5+rtoAq22f3090sTPaXGMUHBlvwshvLmWAcwYAAFZQOCB6AAAAcAIAnQEqEAAQAAVAfCWwAnR/A9kMiKytRkCrIAD+Htyepy36vSGirmCExfHORgK5kPss6pmnFzDoiBm7OTT+Av+xBaQawEMSPm2fuzUMW6fAb1v5gpG4kp2kdhJZdi+G+A7UebKsvCp/RpJNMXmlj2fGRRFds4DhAAA="
};
const __vite_glob_0_2 = {
  sources: sources$t,
  img: img$t
};
const sources$s = {
  webp: [
    {
      src: "/_app/immutable/assets/express-fc.fvHUl1xe.webp",
      w: 50
    }
  ]
};
const img$s = {
  src: "/_app/immutable/assets/express-fc.smtBODD1.png",
  w: 50,
  h: 44,
  lqip: "UklGRkwBAABXRUJQVlA4WAoAAAAQAAAADwAADQAAQUxQSKAAAAABgGJt2zLlft9/fPCu1Z1KpJIn0khk1yVwiKzCIbEIZwO0IY593/fga4iICQCc8tLx5lQRNwCn9hal8FDDgYwNxdQJKekMwxl8VFtS6uhjvYAzWlfSz6BzMPrf/+jomMyZ6vzjFM9YVdKvQffgzLZS/KWtHTKcY4WQFNu6LWJgbLUUQ9RFPwbgLN81VD+sYvzqPrB2spJz50/LDY51uwEAVlA4IIYAAAAQAgCdASoQAA4ABUB8JbACdAYplOFoXJ8AAMpA9Q1BU+b/IRzjlZOJ5iK6KrlFnd/IJB/KAOMPVuqFiVprKZgN7OZVMXuCBkyZsOm4GjEIN+NyqlqWy81K/CKXaRlwxArC3SdCp8CK9yggpV1ffx50H8VnGEdKpN6+NyKkYwIQl9/0/wgAAA=="
};
const __vite_glob_0_3 = {
  sources: sources$s,
  img: img$s
};
const sources$r = {
  webp: [
    {
      src: "/_app/immutable/assets/gaddafi-fc.SSSJf-r5.webp",
      w: 50
    }
  ]
};
const img$r = {
  src: "/_app/immutable/assets/gaddafi-fc.8huzwWXs.png",
  w: 50,
  h: 50,
  lqip: "UklGRkYBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKwAAAABgFvbtmpln/v+/7i7h1AKmUdOBVYAobtHmrlGdEAN7pA52b3v3bPxGiJiAgBU1HYvHp9s9TfVGMBI8gk9SSqfSxAEqKeGzvvQRexCUDXwROWvyo/56mZ65Z9q2T3OiP+MeHRO/Q9V9xj9j2sM/+N5nzpK/1fExQzknNH/5nlVgBhaGOkvITsQg8EMQyXVcQkGEDFrDFVDHiZDAIjICNVzPQWCn2JQ9+j6xAgAVlA4IHQAAABQAgCdASoQABAABUB8JbACdAYs32XqfXuV1sAA+gYS35ZEtrH8h4heR8fmqf3jcLk1WsEBwKLfuK0nyO5rK3xlgJbAmmfdG65KmZODWWDrOxzZLdcyU0cP8uDmfkdGpijzcvx8ZH/24YwyOn6DywiMPajAAA=="
};
const __vite_glob_0_4 = {
  sources: sources$r,
  img: img$r
};
const sources$q = {
  webp: [
    {
      src: "/_app/immutable/assets/kcca-fc.UJ_gfJVf.webp",
      w: 50
    }
  ]
};
const img$q = {
  src: "/_app/immutable/assets/kcca-fc.x8hVIhyP.png",
  w: 50,
  h: 50,
  lqip: "UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKMAAAABgJpt27Llep4Xt+YuiQXctf0HA5BYgBXYgAWIRG2WdBInustzIy/MEBETAJAMw4qMvBm9a8MYWaNp5fBFT9vLbRjg9EnxHqECCYzSLb2F4lX7jUBiSR/6/aE1DGcwFLkFEkbNVSakyUzliT5/hWYz1VcKSfrUXIY9vUn60EMPDs74m971+aFlHMApnOtd14tO3qld1XE36Q8cm28h8U9zzMkCAFZQOCCQAAAAcAIAnQEqEAAQAAVAfCWwAnQwT4iIBrMe6pEZgAD6/xaOHNTziyWELcra0cQWhVcllppf4D1F5kh6ZjbBBWCHk0PsnwGPbvxOi06FxL4Ml1ob9zvG0FVgWCe2042yKg0LpHWiCUERmTL5Jflg5Q/zD6guzbVjl/uQu5xef9iqn3I1n38Y96E8MMja+19DwAAA"
};
const __vite_glob_0_5 = {
  sources: sources$q,
  img: img$q
};
const sources$p = {
  webp: [
    {
      src: "/_app/immutable/assets/kitara-fc.8l5-TjUB.webp",
      w: 50
    }
  ]
};
const img$p = {
  src: "/_app/immutable/assets/kitara-fc.93o4U1Zv.png",
  w: 50,
  h: 47,
  lqip: "UklGRlIBAABXRUJQVlA4WAoAAAAQAAAADwAADgAAQUxQSKwAAAABgJtt27Hnfp/nt7qgzz9CjmzAPkOwMnsno6R3b9s2ut/vc8czRMQEAIDD/51CY4lEPAh1P4Dhg6vX1/vD6TI4ANr4QSNp7IsAAfSxUDIz8wXOQIIYZ56/lrgEUUyx+JvnehyJupzZbyxyKFm7eE3/mzGz3BZc2Lkw/8P4sHqaTnZUV16wQJa81VV0VwGCmjsWi/TNEAAqivQMedIAEXUAIM41taeg+FsEcIqfVlA4IIAAAACQAgCdASoQAA8ABUB8JbAC7DBGiIbKp65y6JpjgAD+Q2dySz3Ip52lFxPdLH8R8/vniipcQX138oS5gyujom4mWPxsubGOFyRCfaTV0cNbNrcWvjmd3U50j+5OFSggUAn4w05bTlM4+yaFIIzIzqmplLDMyM0fkJpYy2009M0AAA=="
};
const __vite_glob_0_6 = {
  sources: sources$p,
  img: img$p
};
const sources$o = {
  webp: [
    {
      src: "/_app/immutable/assets/maroons-fc.fmq0pFM1.webp",
      w: 50
    }
  ]
};
const img$o = {
  src: "/_app/immutable/assets/maroons-fc.D_NRhPz2.png",
  w: 50,
  h: 54,
  lqip: "UklGRl4BAABXRUJQVlA4WAoAAAAQAAAADwAAEAAAQUxQSKUAAAABgFvbtmpl3XP+/7hkFOAS0YNlUAIFEBMRSuYNUAI9kDoRpAxSzfTKRu5/NUTEBPA/uLvR0AOAh1pwelZPj6cwqxgrV8p6PxzFINDak3JMWXcLGM6uYpJUop7mMedEUdWoJbzFVpeit3HMWVSpZJ0DgYF75X9Rmzg4G4qSsh7GCBBonymqRK3jAMbMo76T9jCqxtytyjaBrsbozhrWADOwQNPgTh0AVlA4IJIAAADQAwCdASoQABEAPzmEuVOvKKWisAgB4CcJbAAD4bHoAQZO/2IpZYAA29PMD6dbzD7YB+OssbkdehCu3W9pR6ayYO19AinEpmbHyuU1tg1eNptq/HKVvqSmOrnCsoRot8jAA8tH962H5sCfmxTxC1mgmI2sq4YQTc6aEZc+ddR9w6wO67d5hmzOC8IONqS4RQ1AAA=="
};
const __vite_glob_0_7 = {
  sources: sources$o,
  img: img$o
};
const sources$n = {
  webp: [
    {
      src: "/_app/immutable/assets/mbarara-city-fc.VzKwVR3L.webp",
      w: 50
    }
  ]
};
const img$n = {
  src: "/_app/immutable/assets/mbarara-city-fc.2k7fuJH3.png",
  w: 50,
  h: 42,
  lqip: "UklGRm4BAABXRUJQVlA4WAoAAAAQAAAADwAADQAAQUxQSL8AAAABgBzZtmpl33Nxl7m7J+Du7s6QlwAOAXwiIAlm7u4Oc7Kwe997GwsiIhIQHaSglIIOEgCiAMmuqszQgBIIipcn4/rWjh3dNZsLhYJX8vqFfDslH7JRQ89Y0vd9usZlQ/wJjet5pO+5lq+pWKLlf98yAMROra7QJz2ubwWSoBAZW/HuWmvYHRsLpRB1Sp8kfe5qqIjhI97MTbS2Tiw8cacnNPyMJyUQQKPmips60cmGaK11kBYUODFBCiL4JwIJAgBWUDggiAAAAHACAJ0BKhAADgAFQHwlsAJ0gJeCVIot9c3PrDgA/Sm+qPJ2f+flZO+EYR415HywoGHM7X45vjfTOQMvdWnQqsEjiQvVbv8qPIqYv4/rFfbpF0YcBnj7QUF1+k1cAu22cvMYOh4QG0PLcxFA88Nc1pCCb/9u8jXkZ+nWEWu79oyed34kUdCwAAA="
};
const __vite_glob_0_8 = {
  sources: sources$n,
  img: img$n
};
const sources$m = {
  webp: [
    {
      src: "/_app/immutable/assets/nec-fc.Gs4YH1gU.webp",
      w: 50
    }
  ]
};
const img$m = {
  src: "/_app/immutable/assets/nec-fc.yPZ2WORq.png",
  w: 50,
  h: 56,
  lqip: "UklGRpQBAABXRUJQVlA4WAoAAAAQAAAADwAAEQAAQUxQSMEAAAABgFrbtmpnP/j/66/DzMwcydxBXGRSBFMDzEwqDVALpBgU873vbPGghoiYALhNVLdkw0TQgZl6GAGs5DM+JsB0mZZlWe1v700hy7JMuA3kXzyWwIC7uLejeYki3Gnp6KkD1qlIIYXUPAZ2qUS7HNG8TcIhldBTRLE/5ooO/TWnx6gYaHUokPC6so86gOYEcrY/nQAOG+0tOlpconh00Bh9OV+ko0SU5l4YhlWTicF3ivBvLALLAGAhffr6eaYYpgEAAFZQOCCsAAAAcAQAnQEqEAASAD85hrlTryklorAIAeAnCWwACBA8z8b6baD0nm3i6Bhz3AAA/qEp9wW7RozU+Jogo74VgG2kFs2qBxFJhuZ/BfaOnBL2hUdY9B8WwX5bNBwwlGzvNxifuU0sckXU6Mz81dD6QOI03sRtJKdmK2p3nf4NNEULmCIVQlLVj4C5HbQEij0wcGq+k4FasepbS61DiA5/k2Iee7DEBz/JtrAm3AAAAA=="
};
const __vite_glob_0_9 = {
  sources: sources$m,
  img: img$m
};
const sources$l = {
  webp: [
    {
      src: "/_app/immutable/assets/sc-villa.Bf442Wf5.webp",
      w: 50
    }
  ]
};
const img$l = {
  src: "/_app/immutable/assets/sc-villa.fUbqvozT.png",
  w: 50,
  h: 59,
  lqip: "UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAAEgAAQUxQSJkAAAANgJpt27Llep731+b/j0QWINN8B7ItROYgu1aqJiZwJ2rjvR9cNoiICQB3vo8MSD8AXGPjz/6FqkfL5poYLKcvgpNFQK74ghQAjttXpMw/W/yX+NMw+06f5NkcCKVXCPaGSpETsgKHeGZ7fapvQFG8PN4uksEW5h/mhu1+9skNjHCeJntru6QICBC8PN32IwF1Pmun3K6HgQEAVlA4IJoAAABwBACdASoQABMAPzmEuVOvKKWisAgB4CcJbACdICcEQageREgrEF1F/NakAAD54tnIHFsixSMFzgHEKcxtESZ4DN8wZykqQC2g65z3bvk5uJHxvECeVW9ZDnp+j949AbZ5HanCTVGnV+731b9ykeCuiQIYhsirzR5pWErzzhECjpmUXQsYMxAUu0TEdB8PUiBH1v471RrofYAA"
};
const __vite_glob_0_10 = {
  sources: sources$l,
  img: img$l
};
const sources$k = {
  webp: [
    {
      src: "/_app/immutable/assets/soltilo-bright-stars-fc.DB9vdMGm.webp",
      w: 50
    }
  ]
};
const img$k = {
  src: "/_app/immutable/assets/soltilo-bright-stars-fc.ZEys4-c1.png",
  w: 50,
  h: 50,
  lqip: "UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSLYAAAABgJtt27HnfhGzss0B/jYax8kOSe0VVKdy0jkL2EbH533u4sMMETEBiDpk58IZRI33FtlLq7kw3htE7cAxeTpoEa0cmtonRciD6bEKIEMyCCmBgRmg9SeIkqT+y3cPUPJAZWzgTRkM1ihxwnVYj/E0k3AGVU/UiPK1FhYlHTOUiHCxrRRo/H76k0AG+X/5agUq76hUEaXyrAZARe/I7DV5OzPSW4FYg8advWYYxFrnHPLy4ZyzAFZQOCB+AAAAMAIAnQEqEAAQAAVAfCWwAuwHcC3aXGVKRWgA/nIGyK5ipXvaNBOQv9LUJqnQ11n12Zk0q8dgETZUnz0+52H0X8GHn/AS8HxHgTZUeQ3j13fR/WQ/tlGCoHDZ7w7hziF9Tfgln2n0sxWAog9L2d20AK/zTl9kXNtAiR4vAAAA"
};
const __vite_glob_0_11 = {
  sources: sources$k,
  img: img$k
};
const sources$j = {
  webp: [
    {
      src: "/_app/immutable/assets/updf-fc.5oUnIdE6.webp",
      w: 50
    }
  ]
};
const img$j = {
  src: "/_app/immutable/assets/updf-fc.RUTi67H7.png",
  w: 50,
  h: 50,
  lqip: "UklGRp4BAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSPIAAAABgGvbtrFnn/+PbVuV7aSzbdvJA9ipbFYp7dIp/1TpbNs8rxERAWhIAAKhkEBCGUAAV1uIAYAQhl4ggFqsoeXhoQHNFgUQBLAd7/9i/uoc8IUABIXiU94dG93l63h5EEH5gLuTBnoj2/hUEyQvFf03X/HP/JMx+xcuK+d6/vBw8cE/P/xx/fJ+aKZyyf/8+8f8+8t/fCjtvLpztX3N3998LrreWbEURwgvJr0xPwXPcQDEYaK/zCOhNZW+A7xkIgYoxZmL+GJq4pK3fL1ABPsch9bT//+TBp8UZRAItrn5MRUJQQklmiAABHF7UwtjF3sCAVZQOCCGAAAAUAIAnQEqEAAQAAVAfCWwAnQwR0iDyE/f0ziAAPIuJdPBJMGfN245Xok8VA3p/+ylgl05QHV6kdp/sCQUBdvwTlaN+piOD/NJWKXd/UD3YEcHlrTvxqE9+iT87jqNl2cUSNVAZm+i3rFRboKjYvKdEM2s/ZhPM1r4EJKXKf2bHfrB/foagAA="
};
const __vite_glob_0_12 = {
  sources: sources$j,
  img: img$j
};
const sources$i = {
  webp: [
    {
      src: "/_app/immutable/assets/ura-fc.QYLCEZtF.webp",
      w: 50
    }
  ]
};
const img$i = {
  src: "/_app/immutable/assets/ura-fc.eabvCtF6.png",
  w: 50,
  h: 50,
  lqip: "UklGRmwBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSLkAAAABgGLb2rLlPM//464DsMQikiG5u0t2TRDJlmjMwL0Rya6J5E787MHHEBETACAhAFV+FyUyKy8V0V+E6IlLx31dykcBIWHXfLPAPsrQH4vmeEEQOPaQiyoFbhDYT8fm0TCT5tqvvp0KIRb+c5NCmNn/XEcTptdc3/c8z3dtAxFSrsw3MwsCqyaEMvlxsL++tndsqwJCbHH76Mx0U+vsVFE0P6O6+jqHGwpLezIRQFSFn2Hld9GQqqgAAABWUDggjAAAABADAJ0BKhAAEAAFQHwlsAJ0MErRoIQDVyvKx870UFYSAAD9pmtnlaO+bete6Cqgg7JqabpYN03NI2xq37v6mPvuX+WCzKFMyf6GdGOU/dStkBNrMBHoFi02U8m5L/M5svIOjCk8TUf7dSZGT6a1+hsstAaX/j/TRtrOZ+Nru+uguAhTR0Dy0iPNEAAA"
};
const __vite_glob_0_13 = {
  sources: sources$i,
  img: img$i
};
const sources$h = {
  webp: [
    {
      src: "/_app/immutable/assets/vipers-sc.u8xBo87Z.webp",
      w: 50
    }
  ]
};
const img$h = {
  src: "/_app/immutable/assets/vipers-sc.OcGbkYDr.png",
  w: 50,
  h: 50,
  lqip: "UklGRkIBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKgAAAABgJpt27Llet4HaVBdJ3Aqf8chemYDyyStPoAzhDaNVE2W7Ht5bxxGiIgJ4Ku5u/P/RtH44tpo+CnQ+CLd12E/tV6mdFNP+CbQ8aSU9NhGAIziC0Up6rgQgzw69CYppZQjD5yBH9SOQ1Vlv74mZWPdzdB9m0XFLIsp6rwWY12vb/qa6agEBvc3b7W3MLN7dz813QEFgc4uzKjMgQFmYO4G7oGvIQCYAwBWUDggdAAAAFACAJ0BKhAAEAAFQHwlAALACLSLcAzezOdQgADzwVuF4yfRMChQ3/X3Uz9Awy8aXHVOLK4WOIJvD/agipSw5FYzDHr8DyNtT9TG+uuRwEYXN8ipbV1Gf0a5g21kcy+KOy6a/BCGsP3NoRP9gZBk29MagAAA"
};
const __vite_glob_0_14 = {
  sources: sources$h,
  img: img$h
};
const sources$g = {
  webp: [
    {
      src: "/_app/immutable/assets/wakiso-giants-fc.SUVvG_hv.webp",
      w: 50
    }
  ]
};
const img$g = {
  src: "/_app/immutable/assets/wakiso-giants-fc.P2i-t7Tm.png",
  w: 50,
  h: 60,
  lqip: "UklGRngBAABXRUJQVlA4WAoAAAAQAAAADwAAEgAAQUxQSLgAAAABgGJt2zLl+b9/ZliFRqeyB/IkktMdskNyd3equxMdFgDVne97v2d8thARE+AAyaVjB9c3F4t12QoKOVPvtIxo9vKcmn9ao42IaG0t20/4bxnV/vP8gMIYDc+3aWI7WYlnrY06tp5CSiyaZTmGNpql5CZcUqIJHxJQTxNNswVIe6eNZPmVDYU+6kiaQ1AOEp8oYcLHFDhw4acIKYZ+uABclFO0EVZBIVyh4JN8zodCZBdpq/OpcAEAVlA4IJoAAABwBACdASoQABMAPzmEuVOvKKWisAgB4CcJbACw+iAByqDpyNA0JkpRBE9j4ADJdSj1K24LHWb9xaMuOJzrwSOlgiYKvw5zsrGJV2wB02lCdhYrmxKv1MjolrMKVTd/On+kzFZOUxA5wTgmmf62Py0to0dzWqQzkeisBnGkeJJ7uxN8D4Dfr88RNnVZQ09p/BnHY162LguYGqAA"
};
const __vite_glob_0_15 = {
  sources: sources$g,
  img: img$g
};
const sources$f = {
  avif: [
    {
      src: "/_app/immutable/assets/arua-hill-sc.lEyXxFsW.avif",
      w: 150
    }
  ]
};
const img$f = {
  src: "/_app/immutable/assets/arua-hill-sc.5Z2X8OwL.png",
  w: 150,
  h: 150,
  lqip: "UklGRlABAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKsAAAABgFvbtmpl3+/uSgcOVbhbBwwyhwKgA6iEQQnu7hIS/Yj4yTkbu58WImICABNAtH1ypieBQACAMcHZeyH1fS2GAAzSO1QVUeFBHQZmm45Pkr7LoyQwR5dWhxsIXVFswo98u1BtKuydoLBJj/Mz/1nqJrUJ4WDskWJTNqpYo2tzuQlEd+nKL3H5VIJByylVPE+Eb60IIIDUeoOq/NwqIQAgEECub2F5uIJAAAAAVlA4IH4AAABwAgCdASoQABAABUB8JbACdAYuEgAOTxWkB2ngAPrtwjDVE0j7/X/oVBMi9gq+HpylZyVC6FSpxwGBVd1wGxqWL4CjYk7Up649Kv3B5af4tLJ1GO3MH+ELr3ZMHvkKrTKcz82GzW+dB5KR5rF8m7gl11VzDbaoj8pcQRgAAAA="
};
const __vite_glob_1_0 = {
  sources: sources$f,
  img: img$f
};
const sources$e = {
  avif: [
    {
      src: "/_app/immutable/assets/bul-fc.ghEqnPc5.avif",
      w: 128
    }
  ]
};
const img$e = {
  src: "/_app/immutable/assets/bul-fc.Ob6sUxAG.png",
  w: 128,
  h: 128,
  lqip: "UklGRgwBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSGkAAAABYBRJkpTe/a6gDYTeTpBCIOQa6OYeJESEwrZtm+x0V2cgROR2nOexzYgBAana9dC9Srf32owSbVOfgFIr9VCuKlEYXy6RVlQyfaipGsQvoYZJjk6++I27pPYP8jm4nH5wfHDubs7dzRkAVlA4IHwAAABwAgCdASoQABAABUB8JbACdDiAN5AA6fQ12P7YAMv9Axsm7wuck9KZKDIM1b0Woig8By3Yq1+g5Q5nRf7G7kQ0/hpKBov56mZI2WykFT/ilPAklv/bkq7V6fFN+HaK9zmRugKFaeT7pm5bF29i/oqBPf1YNDaORO8PwAAA"
};
const __vite_glob_1_1 = {
  sources: sources$e,
  img: img$e
};
const sources$d = {
  avif: [
    {
      src: "/_app/immutable/assets/busoga-united-fc.i65iHxsd.avif",
      w: 150
    }
  ]
};
const img$d = {
  src: "/_app/immutable/assets/busoga-united-fc.MAghV_PC.png",
  w: 150,
  h: 150,
  lqip: "UklGRkoBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKkAAAABgJpt27Llet4fd8hUoiVNTGAzsAHRPZMcGpkJXAaguUzgLu/7fvfv/woRMQGAM/KnjLxVA2PL20sjLeQ6Bm+VSIkeFysxg1MF/+99VOwjZdiJgiQlyX9/DmcFFPtKCT04g9NCvjvHnRXRg8PYK/TbhaOmejpf1HlLFVSu30YfpPivh91WqF/5epOil/5+rtoAq22f3090sTPaXGMUHBlvwshvLmWAcwYAAFZQOCB6AAAAcAIAnQEqEAAQAAVAfCWwAnR/A9kMiKytRkCrIAD+Htyepy36vSGirmCExfHORgK5kPss6pmnFzDoiBm7OTT+Av+xBaQawEMSPm2fuzUMW6fAb1v5gpG4kp2kdhJZdi+G+A7UebKsvCp/RpJNMXmlj2fGRRFds4DhAAA="
};
const __vite_glob_1_2 = {
  sources: sources$d,
  img: img$d
};
const sources$c = {
  avif: [
    {
      src: "/_app/immutable/assets/express-fc.htZmGTiQ.avif",
      w: 150
    }
  ]
};
const img$c = {
  src: "/_app/immutable/assets/express-fc.chiBR7TU.png",
  w: 150,
  h: 133,
  lqip: "UklGRkwBAABXRUJQVlA4WAoAAAAQAAAADwAADQAAQUxQSKAAAAABgGJt2zLlft9/fPCu1Z1KpJIn0khk1yVwiKzCIbEIZwO0IY593/fga4iICQCc8tLx5lQRNwCn9hal8FDDgYwNxdQJKekMwxl8VFtS6uhjvYAzWlfSz6BzMPrf/+jomMyZ6vzjFM9YVdKvQffgzLZS/KWtHTKcY4WQFNu6LWJgbLUUQ9RFPwbgLN81VD+sYvzqPrB2spJz50/LDY51uwEAVlA4IIYAAAAQAgCdASoQAA4ABUB8JbACdAYplOFoXJ8AAMpA9Q1BU+b/IRzjlZOJ5iK6KrlFnd/IJB/KAOMPVuqFiVprKZgN7OZVMXuCBkyZsOm4GjEIN+NyqlqWy81K/CKXaRlwxArC3SdCp8CK9yggpV1ffx50H8VnGEdKpN6+NyKkYwIQl9/0/wgAAA=="
};
const __vite_glob_1_3 = {
  sources: sources$c,
  img: img$c
};
const sources$b = {
  avif: [
    {
      src: "/_app/immutable/assets/gaddafi-fc.J67s5rtm.avif",
      w: 150
    }
  ]
};
const img$b = {
  src: "/_app/immutable/assets/gaddafi-fc.n8LzSTrg.png",
  w: 150,
  h: 150,
  lqip: "UklGRkYBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKwAAAABgFvbtmpln/v+/7i7h1AKmUdOBVYAobtHmrlGdEAN7pA52b3v3bPxGiJiAgBU1HYvHp9s9TfVGMBI8gk9SSqfSxAEqKeGzvvQRexCUDXwROWvyo/56mZ65Z9q2T3OiP+MeHRO/Q9V9xj9j2sM/+N5nzpK/1fExQzknNH/5nlVgBhaGOkvITsQg8EMQyXVcQkGEDFrDFVDHiZDAIjICNVzPQWCn2JQ9+j6xAgAVlA4IHQAAABQAgCdASoQABAABUB8JbACdAYs32XqfXuV1sAA+gYS35ZEtrH8h4heR8fmqf3jcLk1WsEBwKLfuK0nyO5rK3xlgJbAmmfdG65KmZODWWDrOxzZLdcyU0cP8uDmfkdGpijzcvx8ZH/24YwyOn6DywiMPajAAA=="
};
const __vite_glob_1_4 = {
  sources: sources$b,
  img: img$b
};
const sources$a = {
  avif: [
    {
      src: "/_app/immutable/assets/kcca-fc.20hT45UR.avif",
      w: 150
    }
  ]
};
const img$a = {
  src: "/_app/immutable/assets/kcca-fc.0hw28sxY.png",
  w: 150,
  h: 150,
  lqip: "UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKMAAAABgJpt27Llep4Xt+YuiQXctf0HA5BYgBXYgAWIRG2WdBInustzIy/MEBETAJAMw4qMvBm9a8MYWaNp5fBFT9vLbRjg9EnxHqECCYzSLb2F4lX7jUBiSR/6/aE1DGcwFLkFEkbNVSakyUzliT5/hWYz1VcKSfrUXIY9vUn60EMPDs74m971+aFlHMApnOtd14tO3qld1XE36Q8cm28h8U9zzMkCAFZQOCCQAAAAcAIAnQEqEAAQAAVAfCWwAnQwT4iIBrMe6pEZgAD6/xaOHNTziyWELcra0cQWhVcllppf4D1F5kh6ZjbBBWCHk0PsnwGPbvxOi06FxL4Ml1ob9zvG0FVgWCe2042yKg0LpHWiCUERmTL5Jflg5Q/zD6guzbVjl/uQu5xef9iqn3I1n38Y96E8MMja+19DwAAA"
};
const __vite_glob_1_5 = {
  sources: sources$a,
  img: img$a
};
const sources$9 = {
  avif: [
    {
      src: "/_app/immutable/assets/kitara-fc.hQZoPIvZ.avif",
      w: 150
    }
  ]
};
const img$9 = {
  src: "/_app/immutable/assets/kitara-fc.BBUV9M35.png",
  w: 150,
  h: 140,
  lqip: "UklGRlIBAABXRUJQVlA4WAoAAAAQAAAADwAADgAAQUxQSKwAAAABgJtt27Hnfp/nt7qgzz9CjmzAPkOwMnsno6R3b9s2ut/vc8czRMQEAIDD/51CY4lEPAh1P4Dhg6vX1/vD6TI4ANr4QSNp7IsAAfSxUDIz8wXOQIIYZ56/lrgEUUyx+JvnehyJupzZbyxyKFm7eE3/mzGz3BZc2Lkw/8P4sHqaTnZUV16wQJa81VV0VwGCmjsWi/TNEAAqivQMedIAEXUAIM41taeg+FsEcIqfVlA4IIAAAACQAgCdASoQAA8ABUB8JbAC7DBGiIbKp65y6JpjgAD+Q2dySz3Ip52lFxPdLH8R8/vniipcQX138oS5gyujom4mWPxsubGOFyRCfaTV0cNbNrcWvjmd3U50j+5OFSggUAn4w05bTlM4+yaFIIzIzqmplLDMyM0fkJpYy2009M0AAA=="
};
const __vite_glob_1_6 = {
  sources: sources$9,
  img: img$9
};
const sources$8 = {
  avif: [
    {
      src: "/_app/immutable/assets/maroons-fc.YbUCLXYD.avif",
      w: 150
    }
  ]
};
const img$8 = {
  src: "/_app/immutable/assets/maroons-fc.RrP59Qgo.png",
  w: 150,
  h: 161,
  lqip: "UklGRl4BAABXRUJQVlA4WAoAAAAQAAAADwAAEAAAQUxQSKUAAAABgFvbtmpl3XP+/7hkFOAS0YNlUAIFEBMRSuYNUAI9kDoRpAxSzfTKRu5/NUTEBPA/uLvR0AOAh1pwelZPj6cwqxgrV8p6PxzFINDak3JMWXcLGM6uYpJUop7mMedEUdWoJbzFVpeit3HMWVSpZJ0DgYF75X9Rmzg4G4qSsh7GCBBonymqRK3jAMbMo76T9jCqxtytyjaBrsbozhrWADOwQNPgTh0AVlA4IJIAAADQAwCdASoQABEAPzmEuVOvKKWisAgB4CcJbAAD4bHoAQZO/2IpZYAA29PMD6dbzD7YB+OssbkdehCu3W9pR6ayYO19AinEpmbHyuU1tg1eNptq/HKVvqSmOrnCsoRot8jAA8tH962H5sCfmxTxC1mgmI2sq4YQTc6aEZc+ddR9w6wO67d5hmzOC8IONqS4RQ1AAA=="
};
const __vite_glob_1_7 = {
  sources: sources$8,
  img: img$8
};
const sources$7 = {
  avif: [
    {
      src: "/_app/immutable/assets/mbarara-city-fc.HA69zUNW.avif",
      w: 150
    }
  ]
};
const img$7 = {
  src: "/_app/immutable/assets/mbarara-city-fc.yrt9MCs8.png",
  w: 150,
  h: 127,
  lqip: "UklGRm4BAABXRUJQVlA4WAoAAAAQAAAADwAADQAAQUxQSL8AAAABgBzZtmpl33Nxl7m7J+Du7s6QlwAOAXwiIAlm7u4Oc7Kwe997GwsiIhIQHaSglIIOEgCiAMmuqszQgBIIipcn4/rWjh3dNZsLhYJX8vqFfDslH7JRQ89Y0vd9usZlQ/wJjet5pO+5lq+pWKLlf98yAMROra7QJz2ubwWSoBAZW/HuWmvYHRsLpRB1Sp8kfe5qqIjhI97MTbS2Tiw8cacnNPyMJyUQQKPmips60cmGaK11kBYUODFBCiL4JwIJAgBWUDggiAAAAHACAJ0BKhAADgAFQHwlsAJ0gJeCVIot9c3PrDgA/Sm+qPJ2f+flZO+EYR415HywoGHM7X45vjfTOQMvdWnQqsEjiQvVbv8qPIqYv4/rFfbpF0YcBnj7QUF1+k1cAu22cvMYOh4QG0PLcxFA88Nc1pCCb/9u8jXkZ+nWEWu79oyed34kUdCwAAA="
};
const __vite_glob_1_8 = {
  sources: sources$7,
  img: img$7
};
const sources$6 = {
  avif: [
    {
      src: "/_app/immutable/assets/nec-fc.Lo4v0ip5.avif",
      w: 150
    }
  ]
};
const img$6 = {
  src: "/_app/immutable/assets/nec-fc.ljzPRPYG.png",
  w: 150,
  h: 167,
  lqip: "UklGRpQBAABXRUJQVlA4WAoAAAAQAAAADwAAEQAAQUxQSMEAAAABgFrbtmpnP/j/66/DzMwcydxBXGRSBFMDzEwqDVALpBgU873vbPGghoiYALhNVLdkw0TQgZl6GAGs5DM+JsB0mZZlWe1v700hy7JMuA3kXzyWwIC7uLejeYki3Gnp6KkD1qlIIYXUPAZ2qUS7HNG8TcIhldBTRLE/5ooO/TWnx6gYaHUokPC6so86gOYEcrY/nQAOG+0tOlpconh00Bh9OV+ko0SU5l4YhlWTicF3ivBvLALLAGAhffr6eaYYpgEAAFZQOCCsAAAAcAQAnQEqEAASAD85hrlTryklorAIAeAnCWwACBA8z8b6baD0nm3i6Bhz3AAA/qEp9wW7RozU+Jogo74VgG2kFs2qBxFJhuZ/BfaOnBL2hUdY9B8WwX5bNBwwlGzvNxifuU0sckXU6Mz81dD6QOI03sRtJKdmK2p3nf4NNEULmCIVQlLVj4C5HbQEij0wcGq+k4FasepbS61DiA5/k2Iee7DEBz/JtrAm3AAAAA=="
};
const __vite_glob_1_9 = {
  sources: sources$6,
  img: img$6
};
const sources$5 = {
  avif: [
    {
      src: "/_app/immutable/assets/sc-villa.LKog1CcI.avif",
      w: 150
    }
  ]
};
const img$5 = {
  src: "/_app/immutable/assets/sc-villa.i7HNtuGr.png",
  w: 150,
  h: 177,
  lqip: "UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAAEgAAQUxQSJkAAAANgJpt27Llep731+b/j0QWINN8B7ItROYgu1aqJiZwJ2rjvR9cNoiICQB3vo8MSD8AXGPjz/6FqkfL5poYLKcvgpNFQK74ghQAjttXpMw/W/yX+NMw+06f5NkcCKVXCPaGSpETsgKHeGZ7fapvQFG8PN4uksEW5h/mhu1+9skNjHCeJntru6QICBC8PN32IwF1Pmun3K6HgQEAVlA4IJoAAABwBACdASoQABMAPzmEuVOvKKWisAgB4CcJbACdICcEQageREgrEF1F/NakAAD54tnIHFsixSMFzgHEKcxtESZ4DN8wZykqQC2g65z3bvk5uJHxvECeVW9ZDnp+j949AbZ5HanCTVGnV+731b9ykeCuiQIYhsirzR5pWErzzhECjpmUXQsYMxAUu0TEdB8PUiBH1v471RrofYAA"
};
const __vite_glob_1_10 = {
  sources: sources$5,
  img: img$5
};
const sources$4 = {
  avif: [
    {
      src: "/_app/immutable/assets/soltilo-bright-stars-fc.aoIUh4cF.avif",
      w: 150
    }
  ]
};
const img$4 = {
  src: "/_app/immutable/assets/soltilo-bright-stars-fc.rZ2_rKEX.png",
  w: 150,
  h: 150,
  lqip: "UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSLYAAAABgJtt27HnfhGzss0B/jYax8kOSe0VVKdy0jkL2EbH533u4sMMETEBiDpk58IZRI33FtlLq7kw3htE7cAxeTpoEa0cmtonRciD6bEKIEMyCCmBgRmg9SeIkqT+y3cPUPJAZWzgTRkM1ihxwnVYj/E0k3AGVU/UiPK1FhYlHTOUiHCxrRRo/H76k0AG+X/5agUq76hUEaXyrAZARe/I7DV5OzPSW4FYg8advWYYxFrnHPLy4ZyzAFZQOCB+AAAAMAIAnQEqEAAQAAVAfCWwAuwHcC3aXGVKRWgA/nIGyK5ipXvaNBOQv9LUJqnQ11n12Zk0q8dgETZUnz0+52H0X8GHn/AS8HxHgTZUeQ3j13fR/WQ/tlGCoHDZ7w7hziF9Tfgln2n0sxWAog9L2d20AK/zTl9kXNtAiR4vAAAA"
};
const __vite_glob_1_11 = {
  sources: sources$4,
  img: img$4
};
const sources$3 = {
  avif: [
    {
      src: "/_app/immutable/assets/updf-fc.7asmzDRQ.avif",
      w: 150
    }
  ]
};
const img$3 = {
  src: "/_app/immutable/assets/updf-fc.PAXmXPb5.png",
  w: 150,
  h: 150,
  lqip: "UklGRp4BAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSPIAAAABgGvbtrFnn/+PbVuV7aSzbdvJA9ipbFYp7dIp/1TpbNs8rxERAWhIAAKhkEBCGUAAV1uIAYAQhl4ggFqsoeXhoQHNFgUQBLAd7/9i/uoc8IUABIXiU94dG93l63h5EEH5gLuTBnoj2/hUEyQvFf03X/HP/JMx+xcuK+d6/vBw8cE/P/xx/fJ+aKZyyf/8+8f8+8t/fCjtvLpztX3N3998LrreWbEURwgvJr0xPwXPcQDEYaK/zCOhNZW+A7xkIgYoxZmL+GJq4pK3fL1ABPsch9bT//+TBp8UZRAItrn5MRUJQQklmiAABHF7UwtjF3sCAVZQOCCGAAAAUAIAnQEqEAAQAAVAfCWwAnQwR0iDyE/f0ziAAPIuJdPBJMGfN245Xok8VA3p/+ylgl05QHV6kdp/sCQUBdvwTlaN+piOD/NJWKXd/UD3YEcHlrTvxqE9+iT87jqNl2cUSNVAZm+i3rFRboKjYvKdEM2s/ZhPM1r4EJKXKf2bHfrB/foagAA="
};
const __vite_glob_1_12 = {
  sources: sources$3,
  img: img$3
};
const sources$2 = {
  avif: [
    {
      src: "/_app/immutable/assets/ura-fc.Ow_4hKAG.avif",
      w: 150
    }
  ]
};
const img$2 = {
  src: "/_app/immutable/assets/ura-fc.o6gZSVYa.png",
  w: 150,
  h: 150,
  lqip: "UklGRmwBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSLkAAAABgGLb2rLlPM//464DsMQikiG5u0t2TRDJlmjMwL0Rya6J5E787MHHEBETACAhAFV+FyUyKy8V0V+E6IlLx31dykcBIWHXfLPAPsrQH4vmeEEQOPaQiyoFbhDYT8fm0TCT5tqvvp0KIRb+c5NCmNn/XEcTptdc3/c8z3dtAxFSrsw3MwsCqyaEMvlxsL++tndsqwJCbHH76Mx0U+vsVFE0P6O6+jqHGwpLezIRQFSFn2Hld9GQqqgAAABWUDggjAAAABADAJ0BKhAAEAAFQHwlsAJ0MErRoIQDVyvKx870UFYSAAD9pmtnlaO+bete6Cqgg7JqabpYN03NI2xq37v6mPvuX+WCzKFMyf6GdGOU/dStkBNrMBHoFi02U8m5L/M5svIOjCk8TUf7dSZGT6a1+hsstAaX/j/TRtrOZ+Nru+uguAhTR0Dy0iPNEAAA"
};
const __vite_glob_1_13 = {
  sources: sources$2,
  img: img$2
};
const sources$1 = {
  avif: [
    {
      src: "/_app/immutable/assets/vipers-sc.41gMr1ht.avif",
      w: 150
    }
  ]
};
const img$1 = {
  src: "/_app/immutable/assets/vipers-sc.9i1gT9fV.png",
  w: 150,
  h: 150,
  lqip: "UklGRkIBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKgAAAABgJpt27Llet4HaVBdJ3Aqf8chemYDyyStPoAzhDaNVE2W7Ht5bxxGiIgJ4Ku5u/P/RtH44tpo+CnQ+CLd12E/tV6mdFNP+CbQ8aSU9NhGAIziC0Up6rgQgzw69CYppZQjD5yBH9SOQ1Vlv74mZWPdzdB9m0XFLIsp6rwWY12vb/qa6agEBvc3b7W3MLN7dz813QEFgc4uzKjMgQFmYO4G7oGvIQCYAwBWUDggdAAAAFACAJ0BKhAAEAAFQHwlAALACLSLcAzezOdQgADzwVuF4yfRMChQ3/X3Uz9Awy8aXHVOLK4WOIJvD/agipSw5FYzDHr8DyNtT9TG+uuRwEYXN8ipbV1Gf0a5g21kcy+KOy6a/BCGsP3NoRP9gZBk29MagAAA"
};
const __vite_glob_1_14 = {
  sources: sources$1,
  img: img$1
};
const sources = {
  avif: [
    {
      src: "/_app/immutable/assets/wakiso-giants-fc.lViBgqdm.avif",
      w: 100
    }
  ]
};
const img = {
  src: "/_app/immutable/assets/wakiso-giants-fc.pNJ6L3xq.png",
  w: 100,
  h: 120,
  lqip: "UklGRngBAABXRUJQVlA4WAoAAAAQAAAADwAAEgAAQUxQSLgAAAABgGJt2zLl+b9/ZliFRqeyB/IkktMdskNyd3equxMdFgDVne97v2d8thARE+AAyaVjB9c3F4t12QoKOVPvtIxo9vKcmn9ao42IaG0t20/4bxnV/vP8gMIYDc+3aWI7WYlnrY06tp5CSiyaZTmGNpql5CZcUqIJHxJQTxNNswVIe6eNZPmVDYU+6kiaQ1AOEp8oYcLHFDhw4acIKYZ+uABclFO0EVZBIVyh4JN8zodCZBdpq/OpcAEAVlA4IJoAAABwBACdASoQABMAPzmEuVOvKKWisAgB4CcJbACw+iAByqDpyNA0JkpRBE9j4ADJdSj1K24LHWb9xaMuOJzrwSOlgiYKvw5zsrGJV2wB02lCdhYrmxKv1MjolrMKVTd/On+kzFZOUxA5wTgmmf62Py0to0dzWqQzkeisBnGkeJJ7uxN8D4Dfr88RNnVZQ09p/BnHY162LguYGqAA"
};
const __vite_glob_1_15 = {
  sources,
  img
};
const modules = /* @__PURE__ */ Object.assign({
  "/src/lib/assets/arua-hill-sc.png": __vite_glob_0_0,
  "/src/lib/assets/bul-fc.png": __vite_glob_0_1,
  "/src/lib/assets/busoga-united-fc.png": __vite_glob_0_2,
  "/src/lib/assets/express-fc.png": __vite_glob_0_3,
  "/src/lib/assets/gaddafi-fc.png": __vite_glob_0_4,
  "/src/lib/assets/kcca-fc.png": __vite_glob_0_5,
  "/src/lib/assets/kitara-fc.png": __vite_glob_0_6,
  "/src/lib/assets/maroons-fc.png": __vite_glob_0_7,
  "/src/lib/assets/mbarara-city-fc.png": __vite_glob_0_8,
  "/src/lib/assets/nec-fc.png": __vite_glob_0_9,
  "/src/lib/assets/sc-villa.png": __vite_glob_0_10,
  "/src/lib/assets/soltilo-bright-stars-fc.png": __vite_glob_0_11,
  "/src/lib/assets/updf-fc.png": __vite_glob_0_12,
  "/src/lib/assets/ura-fc.png": __vite_glob_0_13,
  "/src/lib/assets/vipers-sc.png": __vite_glob_0_14,
  "/src/lib/assets/wakiso-giants-fc.png": __vite_glob_0_15
});
const images = modules;
const imagesBig = /* @__PURE__ */ Object.assign({
  "/src/lib/assets/arua-hill-sc.png": __vite_glob_1_0,
  "/src/lib/assets/bul-fc.png": __vite_glob_1_1,
  "/src/lib/assets/busoga-united-fc.png": __vite_glob_1_2,
  "/src/lib/assets/express-fc.png": __vite_glob_1_3,
  "/src/lib/assets/gaddafi-fc.png": __vite_glob_1_4,
  "/src/lib/assets/kcca-fc.png": __vite_glob_1_5,
  "/src/lib/assets/kitara-fc.png": __vite_glob_1_6,
  "/src/lib/assets/maroons-fc.png": __vite_glob_1_7,
  "/src/lib/assets/mbarara-city-fc.png": __vite_glob_1_8,
  "/src/lib/assets/nec-fc.png": __vite_glob_1_9,
  "/src/lib/assets/sc-villa.png": __vite_glob_1_10,
  "/src/lib/assets/soltilo-bright-stars-fc.png": __vite_glob_1_11,
  "/src/lib/assets/updf-fc.png": __vite_glob_1_12,
  "/src/lib/assets/ura-fc.png": __vite_glob_1_13,
  "/src/lib/assets/vipers-sc.png": __vite_glob_1_14,
  "/src/lib/assets/wakiso-giants-fc.png": __vite_glob_1_15
});
function photoForTeam(teamid) {
  return images[`/src/lib/assets/${teamid}.png`];
}
function photoForTeamBig(teamid) {
  return imagesBig[`/src/lib/assets/${teamid}.png`];
}
function len(obj) {
  return obj && Object.keys(obj).length;
}
function lqipToBackground(lqip) {
  return lqip[0] === "#" ? lqip : `url(data:image/webp;base64,${lqip}) no-repeat center/cover`;
}
const Picture = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { sources: sources2 = {} } = $$props;
  let { sizes = void 0 } = $$props;
  let srcs = [];
  if ($$props.sources === void 0 && $$bindings.sources && sources2 !== void 0)
    $$bindings.sources(sources2);
  if ($$props.sizes === void 0 && $$bindings.sizes && sizes !== void 0)
    $$bindings.sizes(sizes);
  {
    if (len(sources2)) {
      const list = [];
      for (const [format, imgs] of Object.entries(sources2)) {
        list.push({
          format,
          srcset: imgs.map((i) => `${i.src} ${i.w}w`).join()
        });
      }
      srcs = list;
    } else {
      srcs = [];
    }
  }
  return `${len(srcs) ? `<picture>${each(srcs, ({ format, srcset }) => {
    return `<source type="${"image/" + escape(format, true)}"${add_attribute("sizes", sizes, 0)}${add_attribute("srcset", srcset, 0)}>`;
  })} ${slots.default ? slots.default({}) : ``}</picture>` : `${slots.default ? slots.default({}) : ``}`}`;
});
const Picture$1 = Picture;
const SvelteImg = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["src", "sizes", "width", "height", "loading", "decoding", "ref"]);
  let { src = {} } = $$props;
  let { sizes = void 0 } = $$props;
  let { width = void 0 } = $$props;
  let { height = void 0 } = $$props;
  let { loading = "lazy" } = $$props;
  let { decoding = "async" } = $$props;
  let { ref = void 0 } = $$props;
  let sources2 = [];
  let img2 = {};
  let background = void 0;
  if ($$props.src === void 0 && $$bindings.src && src !== void 0)
    $$bindings.src(src);
  if ($$props.sizes === void 0 && $$bindings.sizes && sizes !== void 0)
    $$bindings.sizes(sizes);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.loading === void 0 && $$bindings.loading && loading !== void 0)
    $$bindings.loading(loading);
  if ($$props.decoding === void 0 && $$bindings.decoding && decoding !== void 0)
    $$bindings.decoding(decoding);
  if ($$props.ref === void 0 && $$bindings.ref && ref !== void 0)
    $$bindings.ref(ref);
  sources2 = src.sources || {};
  img2 = src.img || {};
  {
    if (len(img2)) {
      const { lqip } = img2;
      background = lqip ? lqipToBackground(lqip) : void 0;
    }
  }
  return `${len(img2) ? `${validate_component(Picture$1, "Picture").$$render($$result, { sources: sources2, sizes }, {}, {
    default: () => {
      return ` <img${spread(
        [
          { loading: escape_attribute_value(loading) },
          {
            decoding: escape_attribute_value(decoding)
          },
          {
            width: escape_attribute_value(width || img2.w || void 0)
          },
          {
            height: escape_attribute_value(height || img2.h || void 0)
          },
          escape_object($$restProps),
          { src: escape_attribute_value(img2.src) }
        ],
        { styles: { background } }
      )}${add_attribute("this", ref, 0)}>`;
    }
  })}` : ``}`;
});
const Img = SvelteImg;
export {
  Img as I,
  photoForTeamBig as a,
  photoForTeam as p
};
